// extracted by mini-css-extract-plugin
export default {"container":"BrowserCompatibility_container__ax9LA","heading":"BrowserCompatibility_heading__8kKHa","customeRowHeight":"BrowserCompatibility_customeRowHeight__TrYfX"};